import { Component, HostBinding, input, output } from '@angular/core';
import { UmssButtonComponent } from '../button/button.component';
import { UmssIconComponent } from '../icon/icon.component';

export type AlertBannerColoredStatus =
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'neutral';

@Component({
  selector: 'umss-alert-banner-colored',
  standalone: true,
  imports: [UmssIconComponent, UmssButtonComponent],
  templateUrl: './alert-banner-colored.component.html',
  styleUrl: './alert-banner-colored.component.scss'
})
export class UmssAlertBannerColoredComponent {
  @HostBinding('style.display') display = 'block';

  title = input<string>('');
  message = input<string>('');
  iconName = input<string>('');
  iconColorOverride = input<string>('');
  status = input<AlertBannerColoredStatus>('info');

  /** Button */
  showButton = input<boolean>(false);
  buttonLabel = input<string>('');
  buttonVariant = input<'Primary' | 'Secondary' | 'Outline' | 'Ghost'>(
    'Secondary'
  );
  buttonIconName = input<string>('');
  buttonLoading = input<boolean>(false);
  buttonClick = output<void>();

  /** Dismiss */
  dismissible = input<boolean>(false);
  dismiss = output<void>();

  get cardClass(): string {
    return `banner-card banner-card--${this.status()}`;
  }

  get resolvedIconName(): string {
    if (this.iconName()) return this.iconName();

    const defaults: Record<AlertBannerColoredStatus, string> = {
      error: 'phosphorWarningCircle',
      warning: 'phosphorWarning',
      info: 'phosphorInfo',
      success: 'phosphorCheckCircleFill',
      neutral: 'phosphorInfo'
    };
    return defaults[this.status()];
  }

  get iconColor(): string {
    if (this.iconColorOverride()) return this.iconColorOverride();

    const map: Record<AlertBannerColoredStatus, string> = {
      error: 'var(--red-600)',
      warning: 'var(--amber-600)',
      info: 'var(--blue-500)',
      success: 'var(--emerald-600)',
      neutral: 'var(--neutral-500)'
    };
    return map[this.status()];
  }
}
